export const PAGE_NAME = {
    ALREADY_ENROLLED: 'already_enrolled',
    API_ERROR: 'api_error',
    CANCELLED: 'cancelled',
    COMPLETE: 'complete',
    COMPLETE_PROCESSING: 'complete_processing',
    DENIED_ENROLLMENT: 'denied',
    ERROR: 'error',
    START: 'start',
    START_ERROR: 'start:error',
    PENDING_ENROLLMENT: 'start:pending_enrollment'
};
/**
 * Used only to hide cross-border pop-up
 */
export const PAGE_NAME_BY_SCREEN = {
    cancelled: 'cancelled',
    default: 'start',
    denied_enrollment: 'denied',
    enrolled: 'already_enrolled',
    enrollment_success: 'complete_processing',
    generic_error: 'api_error',
    pending: 'start:pending_enrollment',
    technical_error_screen: 'error',
    unenrolled: 'start'
};
